import React from 'react';
import PropTypes from 'prop-types';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSTruncatedTooltipText from '@elliemae/ds-truncated-tooltip-text';
import RequiredMark from '../../RequiredMark/RequiredMark.js';

/* eslint-disable jsx-a11y/label-has-associated-control */
var blockName = 'em-ds-label';
var Text = aggregatedClasses('span')(blockName, 'text');

var DSLabel = function DSLabel(_ref) {
  var children = _ref.children,
      label = _ref.label,
      htmlFor = _ref.htmlFor,
      required = _ref.required,
      optional = _ref.optional,
      _ref$truncateText = _ref.truncateText,
      truncateText = _ref$truncateText === void 0 ? true : _ref$truncateText,
      _ref$isGroup = _ref.isGroup,
      isGroup = _ref$isGroup === void 0 ? false : _ref$isGroup;
  var Tag = isGroup ? 'legend' : 'label';
  return /*#__PURE__*/React.createElement(Tag, {
    className: "".concat(blockName).concat(isGroup ? " ".concat(blockName, "--group") : ''),
    htmlFor: htmlFor
  }, truncateText ? /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    value: children || label
  }) : /*#__PURE__*/React.createElement(Text, null, label), /*#__PURE__*/React.createElement(RequiredMark, {
    optional: optional,
    required: required
  }));
};

DSLabel.propTypes = {
  children: PropTypes.string,
  label: PropTypes.string,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  optional: PropTypes.bool,
  truncateText: PropTypes.bool,
  isGroup: PropTypes.bool
};

export default DSLabel;
//# sourceMappingURL=DSLabel.js.map
